import * as Tiff from 'tiff.js';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ImageConverterService {
  async convertTiffToCanvasImg(blob: Blob): Promise<string> {
    try {
      const ab = await this.convertBlobToArrayBuffer(blob);
      const tiff = new Tiff({ buffer: ab });
      const canvas = tiff.toCanvas();
      const img = canvas.toDataURL();
      return img;
    } catch (e) {
      console.error(e);
      console.error('tiff failed to open');
      return '';
    }
  }

  convertBlobToArrayBuffer(blob: Blob): Promise<ArrayBuffer> {
    return new Promise<ArrayBuffer>((resolve, reject) => {
      let arrayBuffer: ArrayBuffer;
      const fileReader = new FileReader();
      fileReader.onload = function (event) {
        arrayBuffer = <ArrayBuffer>event.target.result;
        resolve(arrayBuffer);
      };

      fileReader.onerror = err => {
        reject(err);
      };

      fileReader.readAsArrayBuffer(blob);
    });
  }
}
